import React, { useState } from 'react';
import { Search, ShoppingCart, Menu, X, ChevronRight, Check, Star, Clock, Shield, Smartphone } from 'lucide-react';


// Trade-in & Features Component
const FeaturesSection = () => {
  const features = [
    {
      icon: <Shield className="w-6 h-6" />,
      title: 'Extended Warranty',
      subtitle: '2-years coverage',
      description: 'Comprehensive coverage for your devices with screen repair included*'
    },
    {
      icon: <Smartphone className="w-6 h-6" />,
      title: 'All Networks available',
      subtitle: 'MTN, Airtel, Glo and others...',
      description: 'Choose from all major network carriers. Get the best deal and data plan'
    },
    {
      icon: <Clock className="w-6 h-6" />,
      title: '24/7 Support',
      subtitle: 'Always online',
      description: 'From setting up to troubleshooting, we are here to help anytime.'
    },
    {
      icon: <Star className="w-6 h-6" />,
      title: 'Maximum value',
      subtitle: 'Up to ₦150,000.00',
      description: 'Trade-in your old device and get instant cash on new purchases.'
    }
  ];

  return (
    <section className="bg-gray-50 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Trade-in Section */}
        <div className="bg-black text-white rounded-3xl p-8 lg:p-16 mb-16">
          <div className="max-w-2xl">
            <h2 className="text-4xl lg:text-5xl font-semibold mb-4">
              Trade Smart.<br />Upgrade Smarter.
            </h2>
            <p className="text-gray-300 text-lg mb-8">
              Exchange your old device for instant credit toward your next purchase. We'll inspect, value, and apply your trade-in in minutes — online or in-store.
            </p>
            <button className="bg-white text-black px-8 py-3 rounded-full font-medium hover:bg-gray-100 transition">
              Start trade-in
            </button>
          </div>
        </div>

        {/* Features Grid */}
        <div className="mb-12">
          <h2 className="text-3xl lg:text-4xl font-semibold text-center mb-12">
            Why Tech Lovers choose us
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 hover:shadow-lg transition-shadow"
              >
                <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mb-4 text-blue-600">
                  {feature.icon}
                </div>
                <h3 className="font-semibold mb-1">{feature.title}</h3>
                <p className="text-sm text-blue-600 mb-2">{feature.subtitle}</p>
                <p className="text-sm text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection